import { frontendURL } from '../../../../helper/URLHelper';
import SalesDeliveryPage from '../pages/SalesDeliveryPage.vue';
import SalesDeliverySummaryPage from '../pages/SalesDeliverySummaryPage.vue';
import SalesDeliveryStartPage from '../pages/SalesDeliveryStartPage.vue';
import SalesDeliverySignaturePage from '../pages/SalesDeliverySignaturePage.vue';
import SalesCommissionRegistration from '../pages/SalesCommissionRegistration.vue';
import SalesReviewPage from '../pages/SalesReviewPage.vue';
import SalesReviewPartyCorrectionPage from '../pages/SalesReviewPartyCorrectionPage.vue';
import SalesReviewPartyPage from '../pages/SalesReviewPartyPage.vue';
import SalesReviewReceiptPage from '../pages/SalesReviewReceiptPage.vue';
import SalesIndex from '../pages/SalesIndex.vue';
import SalesCreate from '../pages/SalesCreate.vue';
import SalesRegistration from '../pages/SalesRegistration.vue';
import SalesReceiptDraftPage from '../pages/SalesReceiptDraftPage.vue';
import SalesPropertyRegistration from '../pages/SalesPropertyRegistration.vue';
import { salesReviewReturnQuery } from '../composables/salesReviewNavigation';
import { salesPermissions } from './permissions';

export const salesCoreRoutes = [
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/revisar-venda/recibo'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/vendas/revisar-venda/:salesTransactionId/recibo'
      ),
      frontendURL(
        'accounts/:accountId/venda/revisar-venda/:salesTransactionId/recibo'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_revisar_recibo',
    component: SalesReviewReceiptPage,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/revisar-venda/:partyRole/:partyId'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/vendas/revisar-venda/:salesTransactionId/:partyRole/:partyId'
      ),
      frontendURL(
        'accounts/:accountId/venda/revisar-venda/:salesTransactionId/:partyRole/:partyId'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_revisar_parte',
    component: SalesReviewPartyCorrectionPage,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/entregar-venda/resumo'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/vendas/entregar-venda/:salesTransactionId/resumo'
      ),
      frontendURL(
        'accounts/:accountId/venda/entregar-venda/:salesTransactionId/resumo'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_entregar_resumo',
    component: SalesDeliverySummaryPage,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/entregar-venda/checkout'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/operacao-imobiliaria/vendas/entregar-venda/:salesTransactionId/checkout'
      ),
      frontendURL(
        'accounts/:accountId/vendas/entregar-venda/:salesTransactionId/checkout'
      ),
      frontendURL(
        'accounts/:accountId/venda/entregar-venda/:salesTransactionId/checkout'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_entregar_checkout',
    component: SalesDeliverySignaturePage,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/entregar-venda'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/vendas/entregar-venda/:salesTransactionId'
      ),
      frontendURL(
        'accounts/:accountId/venda/entregar-venda/:salesTransactionId'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_entregar',
    component: SalesDeliveryStartPage,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/entregar-venda/avaliando'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/operacao-imobiliaria/vendas/entregar-venda/:salesTransactionId/evaluating'
      ),
      frontendURL(
        'accounts/:accountId/vendas/entregar-venda/:salesTransactionId/evaluating'
      ),
      frontendURL(
        'accounts/:accountId/venda/entregar-venda/:salesTransactionId/evaluating'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_entregar_avaliando',
    component: SalesDeliveryPage,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/comissao'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/vendas/gerar-venda/:salesTransactionId/dashboard/comissao'
      ),
      frontendURL(
        'accounts/:accountId/venda/gerar-venda/:salesTransactionId/dashboard/comissao'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_comissao',
    component: SalesCommissionRegistration,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/revisar-venda/:partyRole'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/vendas/revisar-venda/:salesTransactionId/:partyRole'
      ),
      frontendURL(
        'accounts/:accountId/venda/revisar-venda/:salesTransactionId/:partyRole'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_revisar_partes',
    component: SalesReviewPartyPage,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/revisar-venda'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/vendas/revisar-venda/:salesTransactionId'
      ),
      frontendURL(
        'accounts/:accountId/venda/revisar-venda/:salesTransactionId'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_revisar',
    component: SalesReviewPage,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL('accounts/:accountId/operacao-imobiliaria/vendas'),
    alias: [
      frontendURL('accounts/:accountId/operacao-imobiliaria/venda'),
      frontendURL('accounts/:accountId/vendas'),
      frontendURL('accounts/:accountId/venda'),
      frontendURL('accounts/:accountId/sales'),
    ],
    name: 'operacao_imobiliaria_vendas',
    component: SalesIndex,
    meta: { permissions: salesPermissions },
  },
];

export const salesCreationRoutes = [
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/cadastro/recibo'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/vendas/gerar-venda/:salesTransactionId/dashboard/recibo'
      ),
      frontendURL(
        'accounts/:accountId/venda/gerar-venda/:salesTransactionId/dashboard/recibo'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_cadastro_recibo',
    component: SalesReceiptDraftPage,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/gerar-venda'
    ),
    alias: [
      frontendURL('accounts/:accountId/vendas/gerar-venda'),
      frontendURL('accounts/:accountId/venda/gerar-venda'),
    ],
    name: 'operacao_imobiliaria_vendas_nova',
    component: SalesCreate,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/cadastro'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/vendas/gerar-venda/:salesTransactionId/dashboard'
      ),
      frontendURL(
        'accounts/:accountId/venda/gerar-venda/:salesTransactionId/dashboard'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_cadastro',
    component: SalesRegistration,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/vendas/revisar-venda/:salesTransactionId/imovel'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/venda/revisar-venda/:salesTransactionId/imovel'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_revisar_imovel_legado',
    redirect: to => ({
      name: 'operacao_imobiliaria_vendas_cadastro_imovel',
      params: {
        accountId: to.params.accountId,
        salesTransactionId: to.params.salesTransactionId,
      },
      query: salesReviewReturnQuery,
    }),
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/cadastro/imovel'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/vendas/gerar-venda/:salesTransactionId/dashboard/imovel'
      ),
      frontendURL(
        'accounts/:accountId/venda/gerar-venda/:salesTransactionId/dashboard/imovel'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_cadastro_imovel',
    component: SalesPropertyRegistration,
    meta: { permissions: salesPermissions },
  },
];
